import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { toast } from 'sonner';
import api from '../../services/api';

const GUARANTEE_OPTIONS = [
  'Live Foal Guarantee',
  'No Guarantee',
  'Custom'
];

const StudFeeDialog = ({ open, onClose, onSuccess, horse }) => {
  const [formData, setFormData] = useState({
    year: new Date().getFullYear(),
    amount: '',
    guarantee: ''
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.year || !formData.amount) {
      toast.error('Please fill in all required fields');
      return;
    }

    setSaving(true);
    try {
      const payload = {
        horse_id: horse.id,
        year: parseInt(formData.year),
        amount: parseFloat(formData.amount),
        guarantee: formData.guarantee || null
      };

      await api.post('/stud-fees', payload);
      
      // Reset form
      setFormData({
        year: new Date().getFullYear(),
        amount: '',
        guarantee: ''
      });
      
      onSuccess();
    } catch (error) {
      console.error('Error saving stud fee:', error);
      toast.error('Failed to save stud fee');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Add Stud Fee</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Year */}
          <div className="space-y-2">
            <Label>Year *</Label>
            <Input
              type="number"
              value={formData.year}
              onChange={(e) => setFormData({ ...formData, year: e.target.value })}
              placeholder="Enter year"
              min="1900"
              max="2100"
            />
          </div>

          {/* Fee Amount */}
          <div className="space-y-2">
            <Label>Fee (USD$) *</Label>
            <Input
              type="number"
              step="0.01"
              value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
              placeholder="Enter amount"
            />
          </div>

          {/* Guarantee */}
          <div className="space-y-2">
            <Label>Guarantee</Label>
            <Select value={formData.guarantee} onValueChange={(value) => setFormData({ ...formData, guarantee: value })}>
              <SelectTrigger>
                <SelectValue placeholder="Select guarantee" />
              </SelectTrigger>
              <SelectContent className="z-[100]">
                {GUARANTEE_OPTIONS.map(option => (
                  <SelectItem key={option} value={option}>{option}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} disabled={saving}>
              Cancel
            </Button>
            <Button type="submit" disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default StudFeeDialog;
